// Global Instructions Rule Applied!

import { z } from 'zod'

// Shape of one cfg.email_templates row as it appears in
// get_global_configs_v3 -> 'email_templates' (Email Phase 2).
// merge_fields stays z.unknown() — schema evolves with future structured
// templates (plan §1).
export const EmailTemplateModelSchema = z
  .object({
    id: z.string(),
    key: z.string(),
    display_name: z.string(),
    default_subject: z.string(),
    react_component_key: z.string(),
    is_freeform_body: z.boolean(),
    merge_fields: z.unknown(),
    sequence: z.number()
  })
  .strict()

export type EmailTemplateModel = z.infer<typeof EmailTemplateModelSchema>
